// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Ouvrir : la fleche qui mene a la fiche visee par un champ de lien. Cadre
 * LARGE (239 x 176.88), comme le menu : le glyphe garde ses proportions dans
 * la boite carree et s'y centre. Source `open_arrow.svg`.
 */
export const IconOpenArrow = createCustomIcon(
  'IconOpenArrow',
  '0 0 239.01 176.88',
  <polygon
    fill="currentColor"
    points="0 101.39 0 75.5 191.09 75.87 132.97 17.48 150.58 0 239.01 88.41 150.62 176.88 132.96 159.48 190.97 101.1 0 101.39"
  />,
);
